var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCurrencies(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "_20X20_photo_Back",
    "data-name": "20X20 photo Back",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4536",
    "data-name": "Rectangle 4536",
    width: 20,
    height: 20,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_96",
    "data-name": "Mask Group 96",
    clipPath: "url(#clipPath)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "different-currencies"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1_129_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4737",
    "data-name": "Group 4737"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4732",
    "data-name": "Group 4732"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_16055",
    "data-name": "Path 16055",
    d: "M8.813,6.732A6.023,6.023,0,0,1,9.884,3.818a4.862,4.862,0,1,0-5.761,5.8A7.291,7.291,0,0,1,8.813,6.732ZM3.191,6.021A.308.308,0,0,1,3.5,5.707h1V5.474l-.137-.233H3.5a.314.314,0,0,1,0-.627h.491L2.933,2.869a.7.7,0,0,1-.112-.33.624.624,0,0,1,.691-.587.614.614,0,0,1,.547.378L5.137,4.381,6.213,2.33a.615.615,0,0,1,.546-.378.624.624,0,0,1,.691.587.7.7,0,0,1-.112.329L6.277,4.614h.49a.314.314,0,0,1,0,.627h-.86l-.137.233v.233h1a.314.314,0,0,1,0,.627h-1v.8a.593.593,0,0,1-.634.643A.593.593,0,0,1,4.5,7.13v-.8h-1A.308.308,0,0,1,3.191,6.021Z",
    fill: "#404040"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4733",
    "data-name": "Group 4733"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_16056",
    "data-name": "Path 16056",
    d: "M14.863,2.431a4.868,4.868,0,0,0-4.812,4.2,7.251,7.251,0,0,1,2.628.514.339.339,0,0,1,.339-.2h.169a1.5,1.5,0,0,1-.241-.86,1.827,1.827,0,0,1,2.018-1.7c1.409,0,2.091.756,2.091,1.383a.543.543,0,0,1-.6.563c-.707,0-.274-.981-1.359-.981a.842.842,0,0,0-.924.8,1.764,1.764,0,0,0,.265.788h.877c.329,0,.5.121.5.386s-.169.386-.5.386h-.636a.51.51,0,0,1,.041.193,1.037,1.037,0,0,1-.083.384A7.33,7.33,0,0,1,15.369,9a3.175,3.175,0,0,0,.657.1c.136,0,.467-.089.594-.089a.465.465,0,0,1,.466.514c0,.454-.406.651-.824.678a7.357,7.357,0,0,1,.679,1.485,4.859,4.859,0,0,0-2.078-9.253Z",
    fill: "#404040"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4734",
    "data-name": "Group 4734"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_16057",
    "data-name": "Path 16057",
    d: "M10.322,14.5v1.99c.6-.04,1.236-.321,1.236-.985C11.558,14.822,10.863,14.621,10.322,14.5Z",
    fill: "#404040"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4735",
    "data-name": "Group 4735"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_16058",
    "data-name": "Path 16058",
    d: "M8.593,12.119c0,.5.372.794,1.126.945v-1.8C9.034,11.285,8.593,11.686,8.593,12.119Z",
    fill: "#404040"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4736",
    "data-name": "Group 4736"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_16059",
    "data-name": "Path 16059",
    d: "M10,7.842a6.079,6.079,0,1,0,6.08,6.079A6.087,6.087,0,0,0,10,7.842Zm.322,9.674v.623a.3.3,0,1,1-.6,0v-.623c-1.7-.04-2.543-1.055-2.543-1.85a.578.578,0,0,1,.623-.632c1.126,0,.251,1.387,1.92,1.457v-2.1c-1.489-.271-2.391-.924-2.391-2.04a2.2,2.2,0,0,1,2.391-2.11V9.7a.3.3,0,1,1,.6,0v.535c.783.021,2.391.512,2.391,1.5a.6.6,0,0,1-.633.622c-.653,0-.644-1.074-1.757-1.095v1.909c1.327.282,2.5.673,2.5,2.222C12.824,16.742,11.818,17.426,10.322,17.516Z",
    fill: "#404040"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCurrencies);
export default __webpack_public_path__ + "static/media/Currencies.188ab60f5eccccc5fcdf1b9b7d68e2a1.svg";
export { ForwardRef as ReactComponent };